import { Link } from "react-router-dom";
import { Sprout, Trees, Shovel, Flower2, Droplets, Wind, ArrowRight, Check } from "lucide-react";

const services = [
  {
    icon: Sprout,
    title: "Græsslåning",
    text: "Ugentlig, hver 14. dag eller sæson-aftale. Skarpe knive og pæne linjer.",
    bullets: ["Kantklipning", "Opsamling af afklip", "Fast tid hver uge"],
  },
  {
    icon: Trees,
    title: "Beskæring & fældning",
    text: "Beskæring af buske, træer og frugttræer — samt sikker fældning.",
    bullets: ["Frugttræer & prydtræer", "Fældning i højde", "Bortkørsel af grene"],
  },
  {
    icon: Flower2,
    title: "Bede & plantning",
    text: "Nye bede, sæsonplantning og lugning — så haven altid står skarpt.",
    bullets: ["Lugning & rensning", "Ny beplantning", "Barkflis & jord"],
  },
  {
    icon: Shovel,
    title: "Anlæg & fliser",
    text: "Små haveprojekter, lægning af fliser og opbygning af opholdsområder.",
    bullets: ["Terrasser", "Havestier", "Kanter & bede"],
  },
  {
    icon: Droplets,
    title: "Vanding & pleje",
    text: "Vandingsanlæg, gødskning og løbende havepleje gennem sæsonen.",
    bullets: ["Automatisk vanding", "Gødningsplan", "Sæsonpleje"],
  },
  {
    icon: Wind,
    title: "Løvblæsning",
    text: "Efterårsoprydning, løvblæsning og klargøring til vinter.",
    bullets: ["Blæsning & opsamling", "Bortkørsel", "Klargøring"],
  },
];

export default function GardenServices() {
  return (
    <div data-testid="page-garden">
      <section className="mx-auto max-w-7xl px-6 lg:px-10 pt-16 pb-16">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.22em] text-brand-muted mb-4">Havearbejde</div>
          <h1 className="font-display text-5xl sm:text-6xl tracking-tight text-brand-text text-balance">
            Alt haven har brug for — <span className="italic text-brand-primary">samlet ét sted</span>.
          </h1>
          <p className="mt-6 text-lg text-brand-muted leading-relaxed">
            Ud over hækklipning tilbyder vi et bredt program af havepleje. Fra ugentlig græsslåning til større anlægsopgaver — vi hjælper hele sæsonen igennem.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 pb-20">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <div
              key={s.title}
              data-testid={`garden-service-${i}`}
              className="rounded-3xl border border-brand-border bg-brand-surface p-8 hover:shadow-[0_20px_40px_-15px_rgba(42,77,59,0.15)] transition-all"
            >
              <div className="h-12 w-12 rounded-2xl bg-brand-primary text-brand-bg grid place-items-center">
                <s.icon className="h-5 w-5" strokeWidth={1.8} />
              </div>
              <h3 className="font-display text-2xl mt-6 text-brand-text">{s.title}</h3>
              <p className="mt-3 text-brand-muted leading-relaxed">{s.text}</p>
              <ul className="mt-5 space-y-2">
                {s.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-2 text-sm text-brand-text">
                    <Check className="h-4 w-4 text-brand-primary" /> {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 pb-24">
        <div className="rounded-[2.5rem] bg-brand-primary text-brand-bg p-10 lg:p-16 relative overflow-hidden">
          <div className="absolute -top-20 -right-20 h-60 w-60 rounded-full bg-brand-bg/5" />
          <div className="grid lg:grid-cols-2 gap-8 items-center relative">
            <div>
              <h2 className="font-display text-4xl sm:text-5xl tracking-tight">
                Vil du have en fast havemand?
              </h2>
              <p className="mt-4 text-brand-bg/80 max-w-lg">
                Vi tilbyder faste serviceaftaler — så du aldrig skal tænke på haven igen.
              </p>
            </div>
            <div className="flex flex-wrap gap-3 lg:justify-end">
              <Link
                to="/kontakt"
                data-testid="garden-cta-contact"
                className="inline-flex items-center gap-2 rounded-full bg-brand-bg text-brand-primary px-7 py-3.5 font-medium hover:bg-brand-soft"
              >
                Kontakt os <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
